import { connect } from "react-redux";
import PropTypes from "prop-types";

import BaseInputComponent from "basecomponents/BaseInputComponent";
import { InputField, CheckField } from "../components/form";
import { SmallSpinner } from "../components/loaders";

import { hideModal } from "../utils/domUtils";
import { removeNullProperties } from "../utils/jsonUtils";
import { getPrivilegesFromObject } from "../utils/userUtils";

import { createUser } from "../actions/userActions";

class AdminAddUserModal extends BaseInputComponent {
  modal_id = "modal_add_user";

  state = {
    name: "",
    email: "",
    user: "",
    password: "",
    is_active: true,
    is_verified: false,
    // Privilegios
    is_admin: false,
    is_packages: false,
    is_articles: false,
    is_clients: false,
    is_users: false,
    errors: {},
  };

  static getDerivedStateFromProps(nextProps, currentState) {
    let newState = {
      errors: null,
      changed: false,
    };
    if (nextProps.errors) {
      newState.errors = nextProps.errors;
      newState.changed = true;
    }

    if (!newState.changed) return null;

    return removeNullProperties(newState);
  }

  isLoading(): boolean {
    // @ts-ignore
    return this.props.user.loadingOperation;
  }

  onAcceptClick = () => {
    const { user, email, name, password, is_active, is_verified } = this.state;

    // @ts-ignore
    this.props.createUser(
      {
        name,
        email,
        user,
        password,
        is_active,
        is_verified,
        privileges: getPrivilegesFromObject(this.state),
      },
      (success) => {
        if (!success) return;

        this.clearForm();
        this.onCancelClick();
      }
    );
  };

  clearForm = () => {
    this.setState({
      name: "",
      email: "",
      user: "",
      password: "",
      is_active: true,
      is_verified: false,
      // Privilegios
      is_admin: false,
      is_packages: false,
      is_articles: false,
      is_clients: false,
      is_users: false,
    });
  };

  onCancelClick = () => {
    hideModal(this.modal_id);
  };

  getForm = () => {
    const {
      user,
      email,
      name,
      password,
      is_active,
      is_verified,
      errors,
      // Privilegios
      is_admin,
      is_packages,
      is_articles,
      is_clients,
      is_users,
    } = this.state;
    const loading = this.isLoading();
    return (
      <>
        <div className="grid-2-col">
          <InputField
            id="name"
            value={name}
            label="Nombre"
            error={errors}
            onChange={this.onChangeTextInput}
          />
          <InputField
            id="email"
            value={email}
            label="Correo"
            error={errors}
            type="email"
            onChange={this.onChangeTextInput}
          />
        </div>

        <div className="grid-2-col">
          <InputField
            id="user"
            value={user}
            label="Nombre de usuario"
            placeholder="Opcional"
            error={errors}
            onChange={this.onChangeTextInput}
          />
          <InputField
            id="password"
            value={password}
            label="Clave"
            error={errors}
            onChange={this.onChangeTextInput}
            type="password"
          />
        </div>

        <div className="grid-2-col form-row">
          <CheckField
            id="is_active"
            label="Activo"
            checked={is_active}
            onChange={this.onChangeCheckField}
            error={errors}
          />

          <CheckField
            id="is_verified"
            label="Verificado"
            checked={is_verified}
            onChange={this.onChangeCheckField}
            error={errors}
          />
        </div>

        <div>
          <span className="form-row-title">Privilegios</span>
          <div className="grid-2-col form-row">
            <CheckField
              id="is_admin"
              label="Administrador"
              checked={is_admin}
              onChange={this.onChangeCheckField}
              error={errors}
            />

            <CheckField
              id="is_packages"
              label="Paquetes"
              checked={is_packages}
              onChange={this.onChangeCheckField}
              error={errors}
            />
          </div>
          <div className="grid-2-col form-row">
            <CheckField
              id="is_articles"
              label="Articulos"
              checked={is_articles}
              onChange={this.onChangeCheckField}
              error={errors}
            />
            <CheckField
              id="is_clients"
              label="Clientes"
              checked={is_clients}
              onChange={this.onChangeCheckField}
              error={errors}
            />
          </div>

          <div className="grid-2-col form-row">
            <CheckField
              id="is_users"
              label="Usuarios"
              checked={is_users}
              onChange={this.onChangeCheckField}
              error={errors}
            />
          </div>
        </div>

        {loading && <SmallSpinner center={true} />}
      </>
    );
  };

  render() {
    return (
      <div
        className="modal fade"
        id={this.modal_id}
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Crear nuevo usuario</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">{this.getForm()}</div>
            <div className="modal-footer">
              <div className="flex-2-separated">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={this.onCancelClick}
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.onAcceptClick}
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// @ts-ignore
AdminAddUserModal.propTypes = {
  user: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  createUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  createUser,
})(AdminAddUserModal);
